import { Instance } from 'mobx-state-tree'
import { ChapterModelBase } from './ChapterModel.base'

/* The TypeScript type of an instance of ChapterModel */
export interface ChapterModelType extends Instance<typeof ChapterModel.Type> {}

/* A graphql query fragment builders for ChapterModel */
export { selectFromChapter, chapterModelPrimitives, ChapterModelSelector } from './ChapterModel.base'

/**
 * ChapterModel
 */
export const ChapterModel = ChapterModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
